import React from 'react';

interface Level3EmptyProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const Level3Empty = ({width = 500, height = 500, className}: Level3EmptyProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 500 500'
    fill='inherit'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    role='img'
    aria-label='Empty Level 3 Badge'
  >
    <g filter='url(#filter0_i_4102_1380)'>
      <path
        d='M228.083 28.3951C241.697 20.5353 258.469 20.5353 272.083 28.3951L431.166 120.242C444.78 128.102 453.166 142.627 453.166 158.347V342.04C453.166 357.76 444.78 372.285 431.166 380.145L272.083 471.992C258.469 479.852 241.697 479.852 228.083 471.992L69.0001 380.145C55.3865 372.285 47.0001 357.76 47.0001 342.04V158.347C47.0001 142.627 55.3865 128.102 69.0001 120.242L228.083 28.3951Z'
        fill='inherit'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_4102_1380'
        x='47.0001'
        y='22.5002'
        width='406.166'
        height='471.386'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='16' />
        <feGaussianBlur stdDeviation='32' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0' />
        <feBlend mode='normal' in2='shape' result='effect1_innerShadow_4102_1380' />
      </filter>
    </defs>
  </svg>
);
